var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNavArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60983 8.22945C1.75628 8.3759 1.99372 8.3759 2.14017 8.22945L6 4.36962L9.85984 8.22945C10.0063 8.3759 10.2437 8.3759 10.3902 8.22945C10.5366 8.08301 10.5366 7.84557 10.3902 7.69912L6.26517 3.57412C6.11872 3.42768 5.88128 3.42768 5.73484 3.57412L1.60983 7.69912C1.46339 7.84557 1.46339 8.08301 1.60983 8.22945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNavArrowUp);
export default __webpack_public_path__ + "static/media/ic_nav_arrow_up.fc9dced5256201860bf33eeafb5bb16d.svg";
export { ForwardRef as ReactComponent };